import ServiceModel from '../../models/service/ServiceModel.js';

const InboxServiceCollection = Backbone.Collection.extend({
  name: 'services',
  model: ServiceModel,
  isFiltered: false,
  defaults: {
    query: 'unknown',

  },
  initialize() {

  },
  sync(method, collection, options) {
    const { username } = loginContext.getCurrentDetails();
    const api_key = $password;
    let key = `${username}_inbox_services`;
    const defer = $.Deferred();
    const params = {};
    const cache = new Cache();

    if (options.user_id) {
      params.user_id = options.user_id;
      key = `${options.user_id.toString()}_inbox_services`;
    }

    // Possible methods: create, read, update, dete
    if (method == 'read') {
      if (cache.read(key) == null) {
        Sendible.Connect.getInboxServices(window.appConfig.applicationId, username, api_key, (data) => {
          _.each(data, (service) => {
            service.id = service.account_id;
          });

          cache.store(key, JSON.stringify(data), 1);
          options.success(data);
          defer.resolve(data);
        }, (data) => {
          options.error(data.error.message);
          defer.reject(data.error.message);
        });
      } else {
        const data = JSON.parse(cache.read(key));
        _.each(data, (service) => {
          service.id = service.account_id;
        });

        options.success(data);
        defer.resolve(data);
      }
    }

    const promise = defer.promise();
    return promise;
  },

  clearCache() {
    const { username } = loginContext.getCurrentDetails();
    const key = `${username}_inbox_services`;
    const cache = new Cache();

    if (cache.read(key) !== null) {
      cache.remove(key);
    }
  },

  clearAllCache() {
    const cache = new Cache();
    const { username } = loginContext.getCurrentDetails();
    const key = `${username}_inbox_services`;

    cache.removeLike(key);
  },

  parse(data) {
    return data;
  },

  page: 1,

});

export default InboxServiceCollection;
